import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Package, Pencil, Trash2, Plus, Check } from "lucide-react";

export const WorkProductsEditor = ({ strategy, onChange }) => {
  const [name, setName] = useState("");
  const [edit, setEdit] = useState(null);
  const base = `/strategies/${strategy.id}/work-products`;
  const run = async (fn) => {
    try {
      onChange((await fn()).data);
      return true;
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Opslaan mislukt");
      return false;
    }
  };
  const add = async () => {
    if (!name.trim()) return toast.error("Een werkproduct moet een naam hebben");
    if (await run(() => api.post(base, { name }))) setName("");
  };
  const save = async () => {
    if (!edit.name.trim()) return toast.error("Een werkproduct moet een naam hebben");
    if (await run(() => api.patch(`${base}/${edit.id}`, { name: edit.name }))) setEdit(null);
  };
  const items = strategy.work_products || [];

  return (
    <div data-testid="work-products-editor">
      <div className="font-mono text-[11px] uppercase tracking-widest text-zinc-500 mb-2">Werkproducten ({items.length})</div>
      <ul className="space-y-1.5 mb-2">
        {items.map((wp) =>
          edit?.id === wp.id ? (
            <li key={wp.id} className="flex gap-2">
              <Input value={edit.name} onChange={(e) => setEdit({ ...edit, name: e.target.value })} onKeyDown={(e) => e.key === "Enter" && save()} className="rounded-none h-8" data-testid="work-product-edit-input" />
              <Button size="sm" className="rounded-none h-8 bg-zinc-900" onClick={save} data-testid="work-product-save-button"><Check className="h-3.5 w-3.5" /></Button>
              <Button size="sm" variant="outline" className="rounded-none h-8" onClick={() => setEdit(null)}>Annuleren</Button>
            </li>
          ) : (
            <li key={wp.id} className="flex items-center justify-between gap-2 border border-dashed border-zinc-400 px-3 py-1.5 text-sm" data-testid="work-product-item">
              <span className="flex items-center gap-2"><Package className="h-3.5 w-3.5 text-zinc-500" />{wp.name}</span>
              <span className="flex gap-1 shrink-0">
                <Button size="icon" variant="ghost" className="h-6 w-6" onClick={() => setEdit({ id: wp.id, name: wp.name })} data-testid="edit-work-product-button"><Pencil className="h-3 w-3" /></Button>
                <Button size="icon" variant="ghost" className="h-6 w-6 text-red-600" onClick={() => run(() => api.delete(`${base}/${wp.id}`))} data-testid="delete-work-product-button"><Trash2 className="h-3 w-3" /></Button>
              </span>
            </li>
          )
        )}
        {items.length === 0 && <li className="text-sm text-zinc-400">Nog geen werkproducten.</li>}
      </ul>
      <div className="flex gap-2">
        <Input value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} placeholder="Nieuw werkproduct, bijv. 'Klachtenrapportage per kwartaal'" className="rounded-none border-zinc-400 h-9" data-testid="new-work-product-input" />
        <Button variant="outline" className="rounded-none h-9" onClick={add} data-testid="add-work-product-button"><Plus className="h-4 w-4 mr-1" /> Werkproduct</Button>
      </div>
    </div>
  );
};
